/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJob } from '../models/CompanyJob';
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { MassSurveyJobCompanyJobMappings } from '../models/MassSurveyJobCompanyJobMappings';
import type { SurveyJobCompanyJobMapping } from '../models/SurveyJobCompanyJobMapping';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JobMappingService {

    /**
     * Map company job to survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static mapCompanyJobToSurveyJobs({
        requestBody,
    }: {
        requestBody: {
            /**
             * Plan of company
             */
            planId: number;
            /**
             * Company Job that is going to be mapped
             */
            companyJobId: number;
            /**
             * Survey Job Definition ID + Paymarket ID to be mapped to Company Job
             */
            mappings: Array<{
                surveyJobDefinitionId: string;
                paymarketId: number | null;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/job',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company job to survey job definitions mappings
     * @returns any Success
     * @throws ApiError
     */
    public static unmapCompanyJobToSurveyJobs({
        requestBody,
    }: {
        requestBody?: {
            /**
             * Survey Job Definition ID + Paymarket ID mappings to Company Job
             */
            mappingIds: Array<number>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapping/job',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Map company job to survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static massMapCompanyJobToSurveyJobs({
        requestBody,
    }: {
        requestBody: {
            /**
             * Plan of company
             */
            planId: number;
            paymarketId?: number | null;
            isRemoveExistingMappings?: boolean;
            mappings: MassSurveyJobCompanyJobMappings;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/job/mass',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Summary of Map company job to survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static massMapCompanyJobToSurveyJobsSummary({
        requestBody,
    }: {
        requestBody: {
            surveyJobProfileId: string;
            planId: number;
            mappings: MassSurveyJobCompanyJobMappings;
        },
    }): CancelablePromise<Array<(CompanyJob & {
        newMappings?: Array<DHSurveyJobDefinition>;
    })>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/job/mass/summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Search company job - survey job mappings
     * @returns SurveyJobCompanyJobMapping Success
     * @throws ApiError
     */
    public static getJobMappings({
        requestBody,
    }: {
        requestBody?: {
            /**
             * Plan Id
             */
            planId: number;
            /**
             * Company Job Ids
             */
            companyJobIds?: Array<number>;
            /**
             * Survey Job Definition Ids
             */
            surveyJobDefinitionIds?: Array<string>;
        },
    }): CancelablePromise<Array<SurveyJobCompanyJobMapping>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/job/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Job Mapping Details
     * @returns any Success
     * @throws ApiError
     */
    public static updateJobMapping({
        id,
        requestBody,
    }: {
        /**
         * SurveyJobCompanyJobMapping ID
         */
        id: number,
        requestBody: {
            status?: SurveyJobCompanyJobMappingStatus;
            adjustment?: number;
            updateAdjustmentCascade?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapping/job/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
